module.exports = __webpack_public_path__ + "static/media/stormtrooper.881902d4.jpg";